export const ORG_PROVIDER_RETURN_TOKEN_KEY = 'org_provider_return_token';
export const ADMIN_RETURN_STATE_KEY = 'admin_return_state';
